import ReactDOM from 'react-dom';
import React from 'react';
import Main from './views/main';

ReactDOM.render(
    <Main />,
    document.getElementById('app')
);